<template>

  <div class="card card-custom card-stretch gutter-b">

    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">Новые заказы</span>

      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body pt-0">


      <div v-if="load" class="text-center mb-10">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>

      <div v-else-if="orders.length === 0" class="text-center mb-10">
        Заказы не найдены!
      </div>

        <!--begin::Table-->
        <div v-else class="table-responsive">
          <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_2">
            <thead>
            <tr class="text-uppercase">
              <th class="pl-0">#</th>
              <th style="min-width: 120px">Клиент</th>
              <th style="min-width: 150px">Дата заказа</th>
              <th style="min-width: 150px">Итого</th>
              <th style="min-width: 130px">Статус</th>
              <th class="pr-0 text-right" style="min-width: 160px">Действия</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(order, i) in orders">
              <tr v-bind:key="i">
                <td class="pl-0">
                  <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}"
                               class="text-dark-75 text-hover-primary font-size-lg"
                               :class="{'font-weight-bolder' : order.new}"
                  >{{order.id}}</router-link>
                </td>
                <td>
                  <span v-if="order.client"
                        class="text-dark-75 d-block font-size-lg"
                        :class="{'font-weight-bolder' : order.new}"
                  >

                    <router-link :to="{ name: 'Client', params: {id: order.client.id}}">
                      {{ order.client.name + ' ' + order.client.surname }}
                    </router-link>

                  </span>
                </td>
                <td>
                  <span class="text-dark-75 d-block font-size-lg"
                        :class="{'font-weight-bolder' : order.new}">
                    {{ moment(order.created_at).format('lll') }}
                  </span>
                </td>
                <td>
                  <span class="text-dark-75 d-block font-size-lg"
                        :class="{'font-weight-bolder' : order.new}"
                  >
                    {{ numberWithSpaces(order.payment.sum) }} <i class="text-dark icon-nm fas fa-ruble-sign"></i>
                  </span>
                </td>
                <td>

                  <span v-if="order.status.name === 'Обработка'" class="label label-lg label-light-warning label-inline">{{order.status.name}}</span>
                  <span v-else-if="order.status.name === 'Выполнен'" class="label label-lg label-light-success label-inline">{{order.status.name}}</span>
                  <span v-else-if="order.status.name === 'Отменен'" class="label label-lg label-light-danger label-inline">{{order.status.name}}</span>
                  <span v-else class="label label-lg label-light-primary label-inline">{{order.status.name}}</span>

                </td>
                <td class="pr-0 text-right">
                  <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}" class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3">
                    <i class="fas fa-edit"></i></router-link>

                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>

    </div>
    <!--end::Body-->





  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import {GET_ORDERS} from "../../../../core/services/store/orders.module";
require('moment/locale/ru');
export default {
  name: "widget-2",

  mounted(){
    this.getFilter()
    this.interval()
  },

  data() {
    return {

      polling: null,
      moment:moment,

      filter: {
        to: '10',
        trashed: false,
      },
    };
  },

  computed: {
    ...mapGetters({
      layoutConfig: "layoutConfig",
      orders: 'gettersOrders',
      load: 'getOrderLoad',
    })
  },

  methods: {
    numberWithSpaces(x){

      if (x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      } else {
        return 0;
      }

    },

    async getFilter(){
      try {
        await this.$store.dispatch(GET_ORDERS, {'page': 1, 'filter': this.filter})
      } catch (e) {
        this.showAlert('Ошибка загрузки', 'danger', 'toast');
      }
    },



    interval(){
      const get = () => {
        if (this.$route.name === 'dashboard'){
          this.getFilter()
        }
      }
      this.polling = setInterval(() => {
        get()
      }, 60000)
    },
  },

  beforeDestroy () {
    clearInterval(this.polling)
  },

};
</script>
